<template>
  <v-list-item class="px-0 py-2 d-flex flex-column">
    <v-list-item-title class="insights-filter-title">{{ $t('insights.filters.areas')}}</v-list-item-title>
      <v-row align="center" class="pb-1 pt-3">
        <v-col
          v-for="(area, index) in areas"
          :key="index"
          class="pa-0 px-2"
        >
          <v-checkbox
            v-model="selectedAreasModel"
            :value="area"
            dense
            >
            <template v-slot:label>
              <span class="insights-filter-text text-capitalize">{{ area.name }}</span>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
  </v-list-item>
</template>

<script>
export default {
  name: 'AreaFilter',
  props: {
    areas: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedAreas: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  emits: ['selectedAreasInput'],
  computed: {
    selectedAreasModel: {
      get () {
        return this.selectedAreas
      },
      set (value) {
        this.$emit('selectedAreasInput', value)
      }
    }
  }
}
</script>

<style>
</style>
